<template>
    <v-footer class="text-left d-flex flex-column ramp-footer px-8">
        <v-container>
            <div class="d-flex justify-space-between">
                <v-sheet class="ramp-footer-sheets">
                    <v-img
                        contain
                        width="85%"
                        :src="require('@/assets/images/transparent-bpo-logo.png')"
                        class="mb-7"
                    ></v-img>
                    <h3>Outsourcing Transformed</h3>
                    <v-divider :thickness="3" class="ramp-underline-divider border-opacity-100 mt-2 mb-2"></v-divider>
                    <p class="ramp-footer-nav-items">Customized solutions.</p>
                    <p class="ramp-footer-nav-items">Passionate culture.</p>
                    <p class="ramp-footer-nav-items">Committed to your success.</p>
                    <div class="d-flex mt-10">
                        <a href="" class="ramp-footer-nav-social mr-5">
                            <v-img
                                height="40px"
                                width="40px"
                                contain
                                :src="require('@/assets/images/footer-twitter.png')"
                            ></v-img>
                        </a>
                        <a href="" class="ramp-footer-nav-social mr-5">
                            <v-img
                                height="40px"
                                width="40px"
                                contain
                                :src="require('@/assets/images/footer-facebook.png')"
                            ></v-img>
                        </a>
                        <a href="" class="ramp-footer-nav-social mr-5">
                            <v-img
                                height="40px"
                                width="40px"
                                contain
                                :src="require('@/assets/images/footer-linkedin.png')"
                            ></v-img>
                        </a>
                        <a href="" class="ramp-footer-nav-social mr-5">
                            <v-img
                                height="40px"
                                width="40px"
                                contain
                                :src="require('@/assets/images/footer-youtube.png')"
                            ></v-img>
                        </a>
                    </div>
                </v-sheet>
                <v-sheet class="ramp-footer-sheets no-mobile">
                    <h3>Jobs by Service</h3>
                    <v-divider :thickness="3" class="ramp-underline-divider border-opacity-100 mt-2 mb-2"></v-divider>
                    <p class="ramp-footer-nav-items">Inbound Voice</p>
                    <p class="ramp-footer-nav-items">Outbound Voice</p>
                    <p class="ramp-footer-nav-items">Multi-channel Support</p>
                    <p class="ramp-footer-nav-items">Back-office Support</p>
                    <p class="ramp-footer-nav-items">Work-Secure Suite</p>
                </v-sheet>
                <v-sheet class="ramp-footer-sheets no-mobile">
                    <h3>Jobs by Location</h3>
                    <v-divider :thickness="3" class="ramp-underline-divider border-opacity-100 mt-2 mb-2"></v-divider>
                    <p class="ramp-footer-nav-items">Corporate Headquarters</p>
                    <p class="ramp-footer-nav-items">Belize</p>
                    <p class="ramp-footer-nav-items">Jamaica</p>
                    <p class="ramp-footer-nav-items">Philippines</p>
                </v-sheet>
                <v-sheet class="ramp-footer-sheets no-mobile">
                    <h3>Jobs by Setup</h3>
                    <v-divider :thickness="3" class="ramp-underline-divider border-opacity-100 mt-2 mb-2"></v-divider>
                    <p class="ramp-footer-nav-items">Remote</p>
                    <p class="ramp-footer-nav-items">On-site</p>
                    <p class="ramp-footer-nav-items">Hybrid</p>
                    <h3>Jobs by Employment</h3>
                    <v-divider :thickness="3" class="ramp-underline-divider border-opacity-100 mt-2 mb-2"></v-divider>
                    <p class="ramp-footer-nav-items">Full-Time</p>
                    <p class="ramp-footer-nav-items">Part-Time</p>
                    <p class="ramp-footer-nav-items">Contractual</p>
                </v-sheet>
            </div>
            <div class="mt-5">
                <img
                    class="side-city"
                    :src="require('@/assets/images/footer-city.png')"
                />
                <img
                    class="mid-city"
                    :src="require('@/assets/images/footer-city.png')"
                />
                <img
                    class="side-city"
                    :src="require('@/assets/images/footer-city.png')"
                />
            </div>
            <div class="d-flex justify-space-between mt-4">
                <a href="" class="ramp-footer-copyrights">&copy; Built in {{ new Date().getFullYear() }}</a>
                <v-spacer></v-spacer>
                <a href="" class="ramp-footer-copyrights-nav">About TBPO</a>
                <a href="" class="ramp-footer-copyrights-nav">Privacy Policy</a>
                <a href="" class="ramp-footer-copyrights-nav">Terms of Use</a>
            </div>
        </v-container>
    </v-footer>
</template>
<style scoped>
.side-city{
    width:27%;
    height:auto;
}
.mid-city{
    width:46%;
    height:auto;
}
body{
    font-size:16px;
    font-family: 'inter';
}
html,body
{
    width: 100%;
    height: 100%;
    margin: 0px;
    padding: 0px;
    overflow-x: hidden; 
}
h1{
  font-family: 'inter';
  font-size:48px;
  font-weight: 700;
  letter-spacing: 0.48px;
}
h3{
    color: #FFF;
    font-size: 22px;
    font-weight: 700;
    line-height: 2.5rem;
}
.ramp-underline-divider
{
    width:30%;
    border-color: var(--vt-c-yellow);
}
.ramp-footer
{
    padding-top:94px;
    background: #002B44;
    /* background-image: url('@/src/assets/images/footer-background.png'); */
    background-blend-mode: color-dodge;
}
.ramp-footer-nav-items
{
    color: #FFF;
    font-size: 16px;
    line-height:30px;
}
.ramp-footer-copyrights
{
    color: #FFF;
    font-size: 12px;
    font-family: Inter;
}
.ramp-footer-copyrights-nav
{
    padding-left:25px;
    color: #FFF;
    font-size: 12px;
    font-family: Inter;
}
.ramp-footer-copyrights:hover, .ramp-footer-copyrights-nav:hover
{
    background:transparent !important;
}
.ramp-footer-sheets
{
    background:transparent;
}
.ramp-footer-nav-social
{
    flex-shrink: 0;
}
@media only screen and (max-width: 600px) {
    .no-mobile{ display:none; }
}
@media only screen and (min-width: 601px) and (max-width: 900px) {

}
</style>